// extracted by mini-css-extract-plugin
export default {"table-container":"table-container--z5obG","commercial":"commercial--Rof51","icon":"icon--anXzR"};